import React from 'react';
import PropTypes from 'prop-types';

import Container from './components/Container';
import Price from './components/Price';
import NoTaxesMessage from './components/NoTaxesMessage';

function ProductItemPrice({
  priceWithDiscount,
  price,
  className,
  subsidizedProduct,
  discount,
  finalPriceWithoutTaxes,
}) {
  return (
    <>
      {!!price && (
        <Container className={className}>
          <Price
            value={priceWithDiscount || price}
            discount={Boolean(priceWithDiscount) || discount}
            subsidized={Boolean(subsidizedProduct?.originalPrice)}
          />
          {priceWithDiscount && <Price ariaHidden value={price} original />}
          {!!subsidizedProduct?.originalPrice && (
            <Price
              ariaHidden
              value={subsidizedProduct.originalPrice}
              original
            />
          )}
        </Container>
      )}
      {!!finalPriceWithoutTaxes && (
        <NoTaxesMessage>
          <span>Sin impuestos</span>
          <Price ariaHidden value={finalPriceWithoutTaxes} />
        </NoTaxesMessage>
      )}
    </>
  );
}

ProductItemPrice.propTypes = {
  price: PropTypes.number.isRequired,
  priceWithDiscount: PropTypes.number,
  finalPriceWithoutTaxes: PropTypes.number,
  className: PropTypes.string,
  subsidizedProduct: PropTypes.object,
  discount: PropTypes.bool,
};

ProductItemPrice.defaultProps = {
  className: '',
  discount: false,
};

export default ProductItemPrice;
